import type { MailboxInfo } from "owa-client-types";
import folderNameToId from "owa-session-store/lib/utils/folderNameToId";
import { getUnifiedInboxDistinguishedFolderId } from "owa-folders-data-utils/lib/getUnifiedInboxDistinguishedFolderId";
import { isUnifiedInboxFolder } from "./isUnifiedInboxFolder";

// Gets the real UnifiedInbox folder id for the account/mailboxinfo if folderId is a UnifiedInbox one
export function getFolderIdOrUnifiedInboxFolderId(folderId: string | undefined, mailboxInfo: MailboxInfo): string | undefined {
    if (folderId && isUnifiedInboxFolder(folderId)) {
        return folderNameToId(getUnifiedInboxDistinguishedFolderId(folderId), mailboxInfo);
    }
    
    return folderId;
}
